import { Scale } from '@blade/common/utils/auto-scale';
import colors from '@/styles/color.scss';
export const echartData = {
    title: {
        text: '{val|0}{percent|%}',
        textStyle: {
            color: colors.lineFillStyle,
            rich: {
                val: {
                    fontFamily: 'Bebas Neue',
                    fontSize: 50 * Scale,
                    lineHeight: 60 * Scale,
                },
                percent: {
                    fontSize: 24 * Scale,
                    lineHeight: 60 * Scale,
                    fontFamily: 'Bebas Neue',
                    verticalAlign: 'bottom',
                },
            },
        },
        // subtext: getLangTxt('saturation'),
        // subtextStyle: {
        //   fontSize: 14 * Scale,
        //   lineHeight: 22 * Scale,
        //   color: colors.legendGray,
        // },
        // itemGap: -10, // 主副标题距离
        left: 'center',
        top: 'center',
    },
    angleAxis: {
        max: 100,
        clockwise: true,
        // 隐藏刻度线
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            show: false
        },
        splitLine: {
            show: false
        }
    },
    radiusAxis: {
        type: 'category',
        // 隐藏刻度线
        axisLine: {
            show: false
        },
        axisTick: {
            show: false
        },
        axisLabel: {
            show: false
        },
        splitLine: {
            show: false
        }
    },
    polar: {
        center: ['50%', '50%'],
        radius: 120 * Scale // 图形大小
    },
    series: [
        {
            type: 'bar',
            data: [{
                    name: 'peak',
                    value: 0,
                    itemStyle: {
                        normal: {
                            color: colors.lineFillStyle,
                        }
                    },
                }],
            coordinateSystem: 'polar',
            roundCap: true,
            barWidth: 23,
            barGap: '-100%',
            z: 2,
        },
        {
            type: 'bar',
            data: [{
                    value: 100,
                    itemStyle: {
                        color: colors.boardItemHover,
                        shadowColor: colors.boardItemHover,
                        shadowBlur: 5,
                        shadowOffsetY: 2
                    }
                }],
            coordinateSystem: 'polar',
            roundCap: true,
            barWidth: 23,
            barGap: '-100%',
            z: 1
        }
    ]
};
